import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import type { AppointmentCalendarEvent } from '../../../types';

interface Props {
  event: AppointmentCalendarEvent;
}
export const AppointmentEvent = ({ event }: Props) => {
  return <div css={containerStyle}>{event.eventType}</div>;
};

const containerStyle = css({
  padding: theme.spacing(0.5),
  borderRadius: theme.borderRadius.small,
  background: theme.colors.white,
  boxShadow: theme.shadows.light,
});
